import {FC, useEffect} from 'react';
import {MemoryRouter} from 'react-router-dom';
import {Provider} from 'react-redux';

import ErrorBoundary from '~/common/ErrorBoundary';
import {renderApp} from '~/loader/render';
import {AppProps} from '~/loader/types';
import {NotificationProvider} from '~/common/Notifications';

import App from './App';
import HamburgerError from './components/HamburgerError/HamburgerError';
import {AppIds} from '../constants';

const Root: FC<AppProps> = ({store}) => {
  useEffect(() => {
    document.getElementById('react-header-app')?.setAttribute('data-rendered', 'true');
  }, []);

  return (
    <Provider store={store}>
      <NotificationProvider>
        <ErrorBoundary errorBody={<HamburgerError />}>
          <MemoryRouter>
            <App />
          </MemoryRouter>
        </ErrorBoundary>
      </NotificationProvider>
    </Provider>
  );
};

renderApp(AppIds.HeaderApp, Root);
